function n(n) {
  return n && "object" == typeof n && "default" in n ? n.default : n;
}

var t = require("react"),
    e = n(require("media-typer")),
    r = n(require("content-type"));

var o = function () {
  function n() {}

  return n.prototype.then = function (t, e) {
    var r = new n(),
        o = this.s;

    if (o) {
      var _n = 1 & o ? t : e;

      if (_n) {
        try {
          u(r, 1, _n(this.v));
        } catch (n) {
          u(r, 2, n);
        }

        return r;
      }

      return this;
    }

    return this.o = function (n) {
      try {
        var _o = n.v;
        1 & n.s ? u(r, 1, t ? t(_o) : _o) : e ? u(r, 1, e(_o)) : u(r, 2, _o);
      } catch (n) {
        u(r, 2, n);
      }
    }, r;
  }, n;
}();

function u(n, t, e) {
  if (!n.s) {
    if (e instanceof o) {
      if (!e.s) return void (e.o = u.bind(null, n, t));
      1 & t && (t = e.s), e = e.v;
    }

    if (e && e.then) return void e.then(u.bind(null, n, t), u.bind(null, n, 2));
    n.s = t, n.v = e;
    var _r = n.o;
    _r && _r(n);
  }
}

var i = {};
!function () {
  function n(n) {
    this._entry = n, this._pact = null, this._resolve = null, this._return = null, this._promise = null;
  }

  function t(n) {
    return {
      value: n,
      done: !0
    };
  }

  function e(n) {
    return {
      value: n,
      done: !1
    };
  }

  n.prototype[Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))] = function () {
    return this;
  }, n.prototype._yield = function (n) {
    return this._resolve(n && n.then ? n.then(e) : e(n)), this._pact = new o();
  }, n.prototype.next = function (n) {
    var e = this;
    return e._promise = new Promise(function (r) {
      var l = e._pact;

      if (null === l) {
        var s = function s(n) {
          e._resolve(n && n.then ? n.then(t) : t(n)), e._pact = null, e._resolve = null;
        };

        var _n2 = e._entry;
        if (null === _n2) return r(e._promise);
        e._entry = null, e._resolve = r, _n2(e).then(s, function (n) {
          if (n === i) s(e._return);else {
            var _t = new o();

            e._resolve(_t), e._pact = null, e._resolve = null, _resolve(_t, 2, n);
          }
        });
      } else e._pact = null, e._resolve = r, u(l, 1, n);
    });
  }, n.prototype.return = function (n) {
    var e = this;
    return e._promise = new Promise(function (r) {
      var o = e._pact;
      if (null === o) return null === e._entry ? r(e._promise) : (e._entry = null, r(n && n.then ? n.then(t) : t(n)));
      e._return = n, e._resolve = r, e._pact = null, u(o, 2, i);
    });
  }, n.prototype.throw = function (n) {
    var t = this;
    return t._promise = new Promise(function (e, r) {
      var o = t._pact;
      if (null === o) return null === t._entry ? e(t._promise) : (t._entry = null, r(n));
      t._resolve = e, t._pact = null, u(o, 2, n);
    });
  };
}(), module.exports = function (n, o) {
  var u = t.useState({
    data: null,
    loading: 0,
    error: null,
    controller: null
  }),
      i = u[0],
      l = u[1],
      s = t.useRef(!1);
  return t.useLayoutEffect(function () {
    return s.current = !0, function () {
      s.current = !1;
    };
  }, []), t.useEffect(function () {
    var t = new AbortController();
    return n && (l(function (n) {
      return {
        data: null,
        loading: n.loading + 1,
        error: null,
        controller: t
      };
    }), function (n, t, o, u) {
      void 0 === t && (t = {});

      try {
        var i = Object.assign({}, t, {
          signal: o
        });
        Promise.resolve(function (t, o) {
          try {
            var l = Promise.resolve(fetch(n, i)).then(function (n) {
              function t() {
                if (!n.ok) {
                  var t = new Error(n.statusText);
                  throw t.status = n.status, t;
                }

                u(function (n) {
                  return Object.assign({}, n, {
                    loading: n.loading - 1
                  });
                });
              }

              var o = n.headers.get("content-type"),
                  i = function () {
                if (o) {
                  var _t2 = function _t2() {
                    u(function (n) {
                      return Object.assign({}, n, {
                        data: i
                      });
                    });
                  };

                  var i = null,
                      l = function (n) {
                    if (n) {
                      var t = r.parse(n),
                          o = e.parse(t.type);
                      if ("json" === o.subtype) return !0;
                      if ("json" === o.suffix) return !0;
                      if (o.suffix && /\bjson\b/i.test(o.suffix)) return !0;
                      if (o.subtype && /\bjson\b/i.test(o.subtype)) return !0;
                    }

                    return !1;
                  }(o) ? Promise.resolve(n.json()).then(function (n) {
                    i = n;
                  }) : Promise.resolve(n.text()).then(function (n) {
                    i = n;
                  });
                  return l && l.then ? l.then(_t2) : _t2();
                }
              }();

              return i && i.then ? i.then(t) : t();
            });
          } catch (n) {
            return o(n);
          }

          return l && l.then ? l.then(void 0, o) : l;
        }(0, function (n) {
          var t = "AbortError" !== n.name ? n : null;
          u(function (n) {
            return Object.assign({}, n, {
              error: t,
              loading: n.loading - 1
            });
          });
        }));
      } catch (n) {
        return Promise.reject(n);
      }
    }(n, o, t.signal, function (n) {
      s.current && l(n);
    })), function () {
      return t.abort();
    };
  }, [o, n]), {
    data: i.data,
    loading: !!i.loading,
    error: i.error,
    abort: function abort() {
      return i.controller && i.controller.abort();
    }
  };
};